var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"btn-center btn-cu btn-l btn-fw bt_ctrib",attrs:{"aria-disabled":_vm.isLoaded,"id":"loginClaveTributaria"},on:{"click":_vm.signInClaveTributaria}},[_c('img',{attrs:{"src":_vm.claveTributariaTxt}})])}
var staticRenderFns = []

export { render, staticRenderFns }